import { Component, EventEmitter, Inject, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { DateAdapter, provideNativeDateAdapter, NativeDateAdapter } from '@angular/material/core';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { CommonModule, DatePipe } from '@angular/common';
import { DatePickerModalComponent } from '../datepicker-modal/datepicker-modal.component';
import { setHours, setMinutes } from 'date-fns';
import { MatMenuModule } from '@angular/material/menu';
import { DateTime } from 'luxon';

export class CustomDateAdapter extends NativeDateAdapter {
  override getFirstDayOfWeek(): number {
    return 1;
  }
}

@Component({
  selector: 'app-modal-simple-datetime',
  imports: [
    MatDatepickerModule,
    DatePipe,
    TranslocoModule,
    CommonModule,
    MatMenuModule
  ],
  providers: [provideNativeDateAdapter(), DatePipe, { provide: DateAdapter, useClass: CustomDateAdapter }],
  templateUrl: './modal-simple-datetime.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './modal-simple-datetime.component.scss'
})
export class ModalSimpleDatetimeComponent {

  minutes: string[] = ['00', '15', '30', '45'];
  hours: string[] = [];
  locale: string = "";
  currentTab = 'date';
  minDate = new Date();
  selectedDatetime: Date = new Date();
  selectedHour: string | null = null;
  selectedMinute: string | null = null;
  @Output() selectDatetimeEvent = new EventEmitter();
  type: any;

  constructor(
    private _adapter: DateAdapter<any>,
    private translocoService: TranslocoService,
    public dialogRef: MatDialogRef<DatePickerModalComponent>,
    public datepipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public data: {
      type: any,
      selectedDate: any,
      minDate: any,

    },
  ) {
    this.hours = Array.from({ length: 24 }, (_, i) => (i < 10 ? '0' + i : '' + i));

    if (data.selectedDate) {
      this.selectedDatetime = data.selectedDate;
    } else {
      this.selectedDatetime = new Date();
    }
    this.selectedHour = null;
    this.selectedMinute = null;

    this.type = data.type;
    this.minDate = data.minDate ? data.minDate : new Date();

    this.translocoService.langChanges$.subscribe((lang) => {
      this.locale = lang;
      this._adapter.setLocale(this.locale);
    });
  }

  changeDate(event: any) {
    if (event) {
      let d = new Date(event);
      if (this.selectedHour !== null) {
        d = setHours(d, parseInt(this.selectedHour, 10));
      }
      if (this.selectedMinute !== null) {
        d = setMinutes(d, parseInt(this.selectedMinute, 10));
      }
      this.selectedDatetime = d;
    }
  }

  changeHour(event: any) {
    this.selectedHour = event;
    const newHour = parseInt(event, 10);
    this.selectedDatetime = setHours(this.selectedDatetime || new Date(), newHour);
  }

  changeMinute(event: any) {
    this.selectedMinute = event;
    const newMinute = parseInt(event, 10);
    this.selectedDatetime = setMinutes(this.selectedDatetime || new Date(), newMinute);
  }

  changeTab(tab: any) {
    this.currentTab = tab;
  }

  isPastTimeSelected(): boolean {
    if (!this.selectedDatetime || this.selectedHour === null || this.selectedMinute === null) {
      return false;
    }
    const dateObj = new Date(this.selectedDatetime);
    if (isNaN(dateObj.getTime())) {
      return false;
    }
    const swedenZone = 'Europe/Stockholm';
    const year = dateObj.getFullYear();
    const month = dateObj.getMonth() + 1;
    const day = dateObj.getDate();
    const hour = dateObj.getHours();
    const minute = dateObj.getMinutes();

    const selectedInSweden = DateTime.fromObject({
      year,
      month,
      day,
      hour,
      minute
    }, { zone: swedenZone });

    const nowInSweden = DateTime.now().setZone(swedenZone);

    return selectedInSweden < nowInSweden;
  }

  isDoneDisabled(): boolean {
    return this.selectedHour === null || this.selectedMinute === null || this.isPastTimeSelected();
  }

  setDatetime() {
    if (this.isDoneDisabled()) {
      return;
    }
    this.selectDatetimeEvent.emit({ datetime: this.selectedDatetime, type: this.type });
    this.dialogRef.close();
  }

}
